export default defineNuxtRouteMiddleware((to) => {
  const normalized = to.path.replace(/\/$/, '') || '/';
  if (!/\/training$/.test(normalized)) return;

  const segments = normalized.split('/').filter(Boolean);
  const last = segments.length - 1;
  if (last >= 1 && segments[last] === 'training' && segments[last - 1] === 'admin') return;

  const token = useCookie('token');
  if (!token.value) {
    return navigateTo(`/auth/login?redirect=${encodeURIComponent(to.fullPath)}`);
  }
  return navigateTo('/developer-vault', { replace: true });
});
